import sessionStorageService from '../services/sessionStorageService';
import storageKeys from '../constants/storageKeys';
function buildId(dimensions) {
    return `${dimensions.country}_${dimensions.brand}_finance_form_input`;
}
export const financeFormInputStorage = {
    get: (dimensions) => {
        const isInSalesEnablement = JSON.parse(sessionStorageService.get(storageKeys.SE_CONFIG_FINANCEFORMINPUT) ||
            'false');
        const storage = isInSalesEnablement ? sessionStorage : localStorage;
        const data = storage.getItem(buildId(dimensions));
        return data ? JSON.parse(data) : null;
    },
    save: (dimensions, data) => {
        const isInSalesEnablement = JSON.parse(sessionStorageService.get(storageKeys.SE_CONFIG_FINANCEFORMINPUT) ||
            'false');
        const storage = isInSalesEnablement ? sessionStorage : localStorage;
        storage.setItem(buildId(dimensions), JSON.stringify(data));
    },
};
//# sourceMappingURL=financeFormInputStorage.js.map